import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { UserComponent } from './user/user.component';
import { UsersListComponent } from './users-list/users-list.component';
import { UsersRoutingModule } from './users-routing.module';
import { UserPreSharedKeyComponent } from './user-presharedkey/user-presharedkey.component';

@NgModule({
  imports: [
    CommonModule,
    UsersRoutingModule,
    NgxPaginationModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [
    UsersListComponent,
    UserComponent,
    UserPreSharedKeyComponent
  ]
})
export class UsersModule {
}
